import { formatHTML } from "./calendar-card";
(function () {
	if (!$(".js-n-datepicker").length) return;
	const datepicker = $(".js-n-datepicker").flatpickr({
		nextArrow: $(".js-n-back-top svg")[0].outerHTML,
		prevArrow: $(".js-n-back-top svg")[0].outerHTML,
		mode: "range",
		locale: $("html").attr("lang"),
		disableMobile: true,
		monthSelectorType: "static",
		onChange: function (selectedDates) {
			$(".js-n-datepicker-from").val(
				flatpickr.formatDate(selectedDates[0], "Y-m-d")
			);
			if (selectedDates[1]) {
				$(".js-n-datepicker-to").val(
					flatpickr.formatDate(selectedDates[1], "Y-m-d")
				);
				$(".js-n-datepicker-from, .js-n-datepicker-to").trigger("change");
				datepicker.close();
				datepicker.set("disable", [(date) => date.getDay() === 2]);
				get_posts();
			} else {
				datepicker.set("disable", []);
			}
		},
		disable: [(date) => date.getDay() === 2],
	});
	const url = $(".js-n-ajax-url").val();
	const page_id = $(".js-n-current-page-id").val();
	let global_offset = 0;
	const $list = $(".js-n-events-list");
	const $wrapper = $(".n__events__wrapper");
	const $heading = $(".js-n-events-list-heading");
	let dates = {
		from: $(".js-n-date-button.active").data("from"),
		to: $(".js-n-date-button.active").data("to"),
	};
	var type = "week";
	let categories = [];

	$(".js-n-cats-input").each(function () {
		if ($(this).prop("checked")) {
			categories.push($(this).val());
		}
	});

	function showNoResults(text) {
		$list.html(
			`<div class="col-xs-12 n__events__listing__no__r">${text}</div>`
		);
	}
	function toggleSpinner() {
		$wrapper.toggleClass("n__events__wrapper--loading");
	}
	function get_posts(append = false) {
		toggleSpinner();
		$.ajax({
			type: "get",
			dataType: "json",
			contentType: "application/json",
			url,
			data: {
				action: "n_events",
				offset: global_offset,
				page_id,
				dates,
				categories,
				type,
				lang: $("html").attr("lang"),
			},
			success: (res) => {
				if (!res.success) return;
				const {
					posts,
					offset,
					no_results_text,
					date_title,
					total,
					has_more,
				} = res.data;
				global_offset += posts.length;
				if (has_more) {
					$(".n__events__show__more").show();
				} else {
					$(".n__events__show__more").hide();
				}
				if (append) {
					$list.append(formatHTML(posts));
					return toggleSpinner();
				}
				if (!posts.length) {
					showNoResults(no_results_text);
				} else {
					$list.html(formatHTML(posts));
				}
				$heading.html(`${date_title}<span>(${total})</span>`);
				toggleSpinner();
			},
			error: (err) => {
				console.log(err);
			},
		});
	}
	// $('.js-n-datepicker-from, .js-n-datepicker-to').click(function(e){
	//   datepicker.open();
	// });

	$(".js-n-cats-input").change(function () {
		global_offset = 0;
		$(".js-n-all-cats-input").attr("disabled", false);
		$(".js-n-all-cats-input").prop("checked", false);
		categories = [];
		$(".js-n-cats-input:checked").each(function () {
			categories.push($(this).val());
		});
		get_posts();
	});
	$(".js-n-all-cats-input").change(function (e) {
		global_offset = 0;
		$(this).attr("disabled", true);
		$(".js-n-cats-input").each(function () {
			$(this).prop("checked", false);
		});
		categories = [];
		get_posts();
	});
	$(".js-n-date-button").click(function (e) {
		e.preventDefault();
		global_offset = 0;
		dates.from = $(this).data("from");
		dates.to = $(this).data("to");
		type = $(this).data("type");
		$(".js-n-date-button").removeClass("active");
		$(this).addClass("active");
		get_posts();
		$(".js-n-datepicker-to").val("");
		$(".js-n-datepicker-from").val("");
	});
	$(".js-n-datepicker-from").change(function () {
		global_offset = 0;
		dates.from = $(this).val();
		type = "";
		if (!$(".js-n-datepicker-to").val()) {
			dates.to = "";
		}
		$(".js-n-date-button").removeClass("active");
		// get_posts();
	});
	$(".js-n-datepicker-to").change(function (e) {
		global_offset = 0;
		dates.to = $(this).val();
		type = "";
		if (!$(".js-n-datepicker-from").val()) {
			dates.from = "";
		}
		$(".js-n-date-button").removeClass("active");
		// get_posts();
	});
	$(".js-n-date-clear-button").click(function (e) {
		global_offset = 0;
		e.preventDefault();
		dates.from = $('[name="n-js-default-date-from"]').val();
		dates.to = $('[name="n-js-default-date-to"]').val();
		type = "week";
		$(".js-n-date-button").removeClass("active");
		$(".js-n-date-button-default").addClass("active");
		$(".js-n-datepicker-to").val("");
		$(".js-n-datepicker-from").val("");
		get_posts();
	});
	$(".js-n-show-more-events").click(function (e) {
		e.preventDefault();
		get_posts(true);
	});
})();
